/**
 * Thresholds for displaying toolbox buttons.
 */
export const THRESHOLDS = [
  {
    width: 520,
    order: [
      'joinaudio',
      'microphone',
      'whiteboard',
      'participants',
      'tileview',
      'more',
      'settings'
    ]
  },
  {
    width: 470,
    order: [
      'joinaudio',
      'microphone',
      'whiteboard',
      'tileview',
      'more',
      'settings'
    ]
  },
  {
    width: 420,
    order: ['joinaudio', 'microphone', 'whiteboard', 'more', 'settings']
  },
  {
    width: 370,
    order: ['joinaudio', 'microphone', 'more', 'settings']
  },
  {
    width: 225,
    order: ['joinaudio', 'more', 'settings']
  },
  {
    width: 200,
    order: ['joinaudio', 'settings']
  }
];

export const NOT_APPLICABLE = 'N/A';

export const TOOLBAR_TIMEOUT = 4000;

export const DRAWER_MAX_HEIGHT = '80vh - 64px';

export const NOTIFY_CLICK_MODE = {
  ONLY_NOTIFY: 'ONLY_NOTIFY',
  PREVENT_AND_NOTIFY: 'PREVENT_AND_NOTIFY'
};
